/*import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Navbar2 from "./components/Navbar2";

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col font-[utendo]">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
*/
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
function App() {
  return (
    <Router>
      {" "}
      <div className="min-h-screen font-Roboto flex flex-col bg-gray-100 dark:[#010128] text-blue-600 dark:text-gray-200 overflow-hidden">
        {" "}
        <Navbar />{" "}
        <main className="flex-grow">
          {" "}
          <Routes>
            {" "}
            <Route exact path="/" element={<Home />} />{" "}
            <Route path="/about" element={<About />} />{" "}
            <Route path="/services" element={<Services />} />{" "}
            <Route path="/projects" element={<Projects />} />{" "}
            <Route path="/contact" element={<Contact />} />{" "}
          </Routes>{" "}
        </main>{" "}
        <Footer />{" "}
      </div>{" "}
    </Router>
  );
}
export default App;
